import type { FunctionComponent } from 'react';

import { useBetSlice } from '../../../store/slices/bets/selectors';
import { useTrophyIcon } from '../../../store/slices/promotions/selectors';
import { CurrencyConnected } from '../../currency/CurrencyConnected';

import { TotalBetWing } from './TotalBetWing';

export const TotalBetWingConnected: FunctionComponent = () => {
  const totalBet = useBetSlice.totalBet();
  const trophy = useTrophyIcon();

  return <TotalBetWing trophy={trophy} totalBet={<CurrencyConnected value={totalBet} />} />;
};
